import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const CloseOutlinedIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.00049 9.00488L15.0049 15.0093" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.0073 9.00586L9.00291 15.0103" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.9998 21.0089C16.9713 21.0089 21.0016 16.9787 21.0016 12.0071C21.0016 7.0356 16.9713 3.00537 11.9998 3.00537C7.02827 3.00537 2.99805 7.0356 2.99805 12.0071C2.99805 16.9787 7.02827 21.0089 11.9998 21.0089Z" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(CloseOutlinedIcon);
